export default __webpack_public_path__ + "static/media/sustainability3.4a521182.webp";